import React, { useState } from 'react';
import { BiblioStoresTab } from './BiblioStoresTab';
import { BiblioReport } from './BiblioReport';

export function BiblioPage() {
    const [activeTab, setActiveTab] = useState('stores');

    const tabs = [
        { label: 'Tiendas', value: 'stores', render: () => <BiblioStoresTab /> },
        { label: 'Reportes', value: 'report', render: () => <BiblioReport /> },
    ];

    const current = tabs.find((tab) => tab.value === activeTab) || tabs[0];

    return (
        <div className="container">
            <nav className="products mb-4">
                <ul>
                    {tabs.map((tab) => (
                        <li
                            key={tab.value}
                            className={activeTab === tab.value ? 'selected' : ''}
                            onClick={() => setActiveTab(tab.value)}
                        >
                            {tab.label}
                        </li>
                    ))}
                </ul>
            </nav>

            {current.render()}
        </div>
    );
}

export default BiblioPage;
